import { DocumentTableRow } from 'features/knowledgeDocumentViewer/components/advancedSearch/DocumentTableColumns'
import {
  addRecentDocument,
  getRecentDocuments,
} from 'features/knowledgeDocumentViewer/utils/recentDocumentsStorage'
import { useGeckoPermissions } from 'features/permissions'
import { useCallback, useEffect, useState } from 'react'

interface UseRecentDocumentsReturn {
  recentDocuments: DocumentTableRow[]
  addRecentDocument: (document: DocumentTableRow) => void
}

export function useRecentDocuments(siteId?: string): UseRecentDocumentsReturn {
  const [recentDocuments, setRecentDocuments] = useState<DocumentTableRow[]>([])
  const { user } = useGeckoPermissions()

  const userId = user?.id

  // Load initial documents from localStorage
  useEffect(() => {
    if (!userId || !siteId) {
      setRecentDocuments([])
      return
    }

    const loadDocuments = () => {
      setRecentDocuments(getRecentDocuments(userId, siteId))
    }

    loadDocuments()

    // Listen for storage changes from other tabs/windows
    const handleStorageChange = (e: StorageEvent) => {
      if (e.key?.startsWith(`gecko_recent_documents_${userId}_${siteId}`)) {
        loadDocuments()
      }
    }

    window.addEventListener('storage', handleStorageChange)
    return () => window.removeEventListener('storage', handleStorageChange)
  }, [userId, siteId])

  const handleAddRecentDocument = useCallback(
    (document: DocumentTableRow) => {
      if (!userId || !siteId) return

      const updatedDocuments = addRecentDocument(document, userId, siteId)
      setRecentDocuments(updatedDocuments)
    },
    [userId, siteId]
  )

  return {
    recentDocuments,
    addRecentDocument: handleAddRecentDocument,
  }
}
